import background from "./background.gif";
import loader from "./loader.gif";
import socials from "./Socials";
import Status from "./Status";
import BackgroundAudio from "./BackgroundAudio";

export {
  background,
  loader,
  BackgroundAudio,
  socials,
  Status
};
export default {
  background,
  loader,
  BackgroundAudio,
  socials,
  Status
};
